module.exports = __webpack_public_path__ + "img/logoColorizedGold.450b19b4.png";